import { DateFormat, formatDate, now } from "common";
import { Dayjs } from "dayjs";
import { SelectionState } from "types";
import create from "zustand";
import { CreatedAtRangeProps, DateFilterRange } from "./analyticsFilterStore";

export interface GratuitiesDataFilter {
    status: SelectionState;
    guides: SelectionState;
}

const defaultFilters: GratuitiesDataFilter = {
    status: { all: true, selected: [] },
    guides: { all: true, selected: [] },
};

const defaultRange = () => {
    return { from: now().startOf("day"), to: now().endOf("day") };
};

interface GratuitiesFilterStoreState {
    to?: Dayjs;
    from?: Dayjs;
    getFrom: () => Dayjs;
    getTo: () => Dayjs;
    filters: GratuitiesDataFilter;
    setFilters: (filters: Partial<GratuitiesDataFilter>) => void;
    setFrom: (date: Dayjs) => void;
    setTo: (date: Dayjs) => void;
    getDateParams: () => CreatedAtRangeProps;
}

export const useGratuitiesFilterStore = create<GratuitiesFilterStoreState>((set, get) => ({
    from: undefined,
    to: undefined,
    filters: defaultFilters,

    getDateParams() {
        const params = [
            formatDate(get().getFrom(), DateFormat.DATE_TIME_ISO),
            formatDate(get().getTo(), DateFormat.DATE_TIME_ISO),
        ];
        return { [DateFilterRange.CREATED_AT]: params.join(",") };
    },

    setFilters(filters: Partial<GratuitiesDataFilter>) {
        set((state) => ({ filters: { ...state.filters, ...filters } }));
    },

    getFrom() {
        return get().from ?? defaultRange().from;
    },

    getTo() {
        return get().to ?? defaultRange().to;
    },

    setFrom(from: Dayjs) {
        set(() => ({ from }));
    },

    setTo(to: Dayjs) {
        set(() => ({ to }));
    },
}));
